import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import blogImg from "../../assets/blogimg.png";
import img222 from "../../assets/img222.png";

const BlogCardSm = ({ blogObj }) => {
  const formatAMPM = (date) => {
    var day = date.getDate();
    var month = date.getMonth();
    var year = date.getFullYear();
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var strTime = `${day}/${month}/${year} ${hours} : ${minutes} ${ampm}`;
    return strTime;
  };

  const history = useHistory();

  return (
    <div className="col-md-6 col-lg-4">
      {blogObj ? (
        <div
          className="repairing_inr"
          onClick={() =>
            history.push({
              pathname: `blogs/${blogObj.id}`,
              state: { blogData: blogObj },
            })
          }
        >
          <div className="row align-items-center">
            <div className="col-lg-4">
              <div className="blogs_inner">
                <img
                  className="img-fluid"
                  src={blogObj?.image || img222}
                  alt="img"
                  style={{
                    width: "100%",
                    maxWidth: "100%",
                    height: "100%",
                  }}
                />
              </div>
            </div>
            <div className="col-lg-8">
              <div className="blog_content">
                <div className="con_top">
                  <h3>{blogObj?.title}</h3>
                </div>
                <p>{blogObj?.content.substring(0, 69)}</p>
                <div className="con_botm d-flex justify-content-between">
                  <div>
                    <i className="fa fa-repeat" aria-hidden="true"></i>
                    <i className="fa fa-cloud-download" aria-hidden="true"></i>
                  </div>
                  <div>
                    <span>
                      {formatAMPM(new Date(parseInt(blogObj?.date)))}{" "}
                    </span>{" "}
                    {/* <span>2 K Views</span> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default BlogCardSm;
